const createDiff = (left, right) => Object.entries(left).reduce((acc, [key, value]) => (right === null || right === void 0 ? void 0 : right[key]) !== value ? {
  ...acc,
  [key]: right === null || right === void 0 ? void 0 : right[key]
} : acc, {});
const createSubscriberContext = (context, selectors) => selectors.reduce((a, selector) => ({
  ...a,
  [selector]: context === null || context === void 0 ? void 0 : context[selector]
}), {});
const idenityMiddleware = context => context;
export const createContextStore = config => {
  var _config$middleware;
  const initialState = config === null || config === void 0 ? void 0 : config.initialState;
  const middleware = (_config$middleware = config === null || config === void 0 ? void 0 : config.middleware) !== null && _config$middleware !== void 0 ? _config$middleware : idenityMiddleware;
  let state = middleware({
    tenantId: undefined,
    isSiteAdmin: undefined,
    product: undefined,
    subproduct: undefined,
    switcherMenuHasBeenOpened: undefined,
    sessionId: undefined,
    locale: undefined,
    orgId: undefined,
    workspaceId: undefined,
    ...initialState
  });
  const subscribers = new Map();
  const updateSubscribers = (updatedContext, changes) => {
    const changedKeys = Object.keys(changes);
    subscribers.forEach((selectors, subscription) => {
      if (!selectors || changedKeys.find(changedKey => selectors.includes(changedKey))) {
        updateSubscriber({
          subscription,
          context: updatedContext,
          subscriberContext: selectors ? createSubscriberContext(updatedContext, selectors) : updatedContext,
          changes
        });
      }
    });
  };
  const updateSubscriber = ({
    subscription,
    context,
    subscriberContext,
    changes = {}
  }) => {
    subscription({
      subscriberContext,
      changes,
      context
    });
  };
  const update = callback => {
    const newState = middleware(callback(state));
    updateSubscribers(newState, createDiff(state, newState));
    state = newState;
  };
  const subscribe = (...newSubscribers) => {
    newSubscribers.forEach(newSubscriber => {
      const [subscription, selectors, options] = newSubscriber;
      if (options !== null && options !== void 0 && options.updateOnSubscribe) {
        updateSubscriber({
          subscription,
          context: state,
          subscriberContext: selectors ? createSubscriberContext(state, selectors) : state
        });
      }
      subscribers.set(subscription, selectors);
    });
  };
  const unsubscribe = subscription => {
    !!subscription ? subscribers.delete(subscription) : subscribers.clear();
  };
  const getCurrentContext = () => state;
  return {
    update,
    subscribe,
    getCurrentContext,
    unsubscribe
  };
};